import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';


import DragDrop from './DragDrop';
import FillBlanks from './FillBlanks';
import FlipBoard from './FlipBoard';
import MultipleChoice from './MultipleChoice';
import MultipleDropdown from './MultipleDropdown';
import SideDropdown from './SideDropDown';
import SwitchButton from './SwitchButton';
import TrainingDials from './TrainingDials';
import { TrainingImage } from './TrainingImage/TrainingImage';
import TrainingSlider from './TrainingSlider';
import TrainingText from './TrainingText';
import TrainingVideo from './TrainingVideo';
import ArrangeTheWords from './ArrangeTheWords';
import MatchTheSentence from './MatchTheSentence';

const LinkButtons = (props) => {
  document.addEventListener('scroll', () => {
    const buttons = document.querySelector('.trainingContent__linkButtons');
    const text = document.querySelector('.text__container');
    const bodyContent = document.querySelector('.bodyContent');

    if (buttons !== null && window.scrollY - buttons.clientHeight >= text.offsetTop) {
      buttons.style.top = `${window.scrollY - text.offsetTop}px`;
    } else if (buttons !== null) {
      buttons.style.top = `${bodyContent.offsetTop + 40}px`;
    }
  });

  return <div className="trainingContent__linkButtons">{props.buttons}</div>;
};

class TrainingContent extends Component {
  selectQuestion() {
    const {
      contentComplete,
      error,
      correct,
      LinkButtons: buttons,
      type: contentType,
      badge,
      completedBefore,
    } = this.props;
    const { type, layout } = this.props.params;
    const { params } = this.props;

    params.buttons = <LinkButtons buttons={buttons} />;
    params.contentComplete = contentComplete;
    params.error = error;
    params.correct = correct;
    params.badge = badge;
    params.completedBefore = completedBefore;
    params.quizMode = this.props.quizMode ?? false;
    params.quizTimerExpired = this.props.quizTimerExpired ?? false;

    if (this.props.params.length === 0) {
      contentComplete();
    }

    switch (type) {
      case 'stepsValues':
      case 'stepsNormal':
        return {
          slider: <TrainingSlider {...params} />,
          s: <TrainingSlider {...params} />,
          f: <FlipBoard {...params} />,
        }[layout];

      case 'QuestionMultipleChoice':
        return {
          mCD: <MultipleDropdown key={`mCD_${params.UPID}`} {...params} />,
          mC: <MultipleChoice key={`mC_${params.UPID}`} {...params} />,
          mMC: <MultipleChoice key={`mMC_${params.UPID}`} {...params} />,
        }[layout];

      case 'QuestionMultipleChoiceImage':
        return {
          mCI: <MultipleChoice key={`mC_${params.UPID}`} {...params} />,
        }[layout];

      case 'DragAndDrop':
        return <DragDrop {...params} />;
      case 'SideDropdown':
        return <SideDropdown {...params} />;

      case 'QuestionComboLock':
        return {
          dial: <TrainingDials {...params} />,
          d: <TrainingDials {...params} />,
        }[layout];

      case 'QuestionOther':
        return <MultipleChoice {...params} />;

      case 'QuestionFillInTheBlank':
        return {
          fITB: <FillBlanks {...params} title={i18n.translate('questions.fitb')} />,
        }[layout];

      case 'QuestionArrangeTheWords':
        return <ArrangeTheWords {...params} />;

      case 'QuestionMatchTheSentence':
        return <MatchTheSentence {...params} />;

      case 'QuestionTrueFalse':
        return <SwitchButton {...params} />;

      default:
        return '';
    }
  }

  selectContent() {
    const { contentComplete, appId, LinkButtons: buttons, badge, chapterTitle } = this.props;
    const { image, pageType, type, answer } = this.props.params;
    const { params } = this.props;
    params.badge = badge;
    params.buttons = <LinkButtons buttons={buttons} />;
    params.contentComplete = contentComplete;
    params.chapterTitle = chapterTitle;
    params.appId = appId;
    if (answer) {
      params.answer = answer.filter((a) => a !== null && a.length > 0);
    }

    const links = [];
    for (let i = 1; i < 6; i += 1) {
      links.push({ url: params[`link${i}`], type: params[`linkType${i}`] });
    }

    const linksJW = [];
    for (let i = 1; i < 6; i += 1) {
      linksJW.push({ url: params[`linkJW${i}`], type: params[`linkJW${i}`] });
    }

    switch (pageType) {
      case 'Video':
      case 'autoPlay':
        return <TrainingVideo {...params} />;

      case 'Spotify':
      case '':
        return (
          <div>
            {image && <TrainingImage {...params} />}
            <TrainingText {...params} />
          </div>
        );

      case 'Final-Page':
        return (
          <div>
            {image && <TrainingImage {...params} />}
            <TrainingText {...params} />
          </div>
        );

      case 'Introduction':
        return <TrainingText {...params} />;

      case 'Photo':
        return <div>{image && <TrainingImage {...params} type={pageType} />}</div>;

      case 'Webview':
        break;

      default:
        if (type !== undefined) {
          return this.selectQuestion();
        }
    }
    return '';
  }

  render() {
    return <div>{this.selectContent()}</div>;
  }
}

export default TrainingContent;

export { default as ArrangeTheWords } from './ArrangeTheWords';
export { default as LinkButton } from './LinkButton';
export { default as MatchTheSentence } from './MatchTheSentence';
export { default as MultipleChoice } from './MultipleChoice';
export { default as NavigationButton } from './NavigationButton';
export { default as TrainingDials } from './TrainingDials';
export { TrainingImage } from './TrainingImage/TrainingImage';
export { default as TrainingSlider } from './TrainingSlider';
export { default as TrainingText } from './TrainingText';
export { default as TrainingVideo } from './TrainingVideo';

TrainingContent.propTypes = {
  appId: PropTypes.number.isRequired,
  badge: PropTypes.string,
  contentComplete: PropTypes.func.isRequired,
  completedBefore: PropTypes.bool,
  error: PropTypes.func,
  correct: PropTypes.func,
  LinkButtons: PropTypes.arrayOf(PropTypes.element),
  params: PropTypes.shape(),
  chapterTitle: PropTypes.string,
  quizMode: PropTypes.bool,
  quizTimerExpired: PropTypes.bool,
};

TrainingContent.defaultProps = {
  badge: '',
  error: () => {},
  correct: () => {},
  LinkButtons: [],
  params: {},
  completedBefore: false,
  chapterTitle: '',
  quizMode: false,
  quizTimerExpired: false,
};

LinkButtons.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape()),
};

LinkButtons.defaultProps = {
  buttons: [],
};
